import * as S from './styled'
import { useTranslation } from 'react-i18next'

export type IndustryGroupListTableProps = {
  payload
}

export function IndustryGroupListTable({ payload }) {
  const { t } = useTranslation()
  return (
    <S.Wrapper data-testid="IndustryGroupListTable">
      <S.ScrollWrapper>
        <S.Table id="table-modal">
          <tbody>
            <S.Line>
              <S.Header>{t('tables:groupName')}</S.Header>
              <S.Header>{t('tables:adminName')}</S.Header>
              <S.Header>{t('tables:adminEmail')}</S.Header>
            </S.Line>
            {payload.map((each, key) => (
              <S.Line id="values" key={key}>
                <S.Column>{each.name}</S.Column>
                <S.Column>{each.admin.name}</S.Column>
                <S.Column>{each.admin.email}</S.Column>
              </S.Line>
            ))}
          </tbody>
        </S.Table>
      </S.ScrollWrapper>
    </S.Wrapper>
  )
}
